module.exports = __webpack_public_path__ + "fonts/c897230.woff";